/**
 * DashboardShell — top-nav layout.
 *
 * The vertical Sidebar was replaced by a horizontal MegaMenu that lives in the
 * top bar (it handles both the desktop dropdown nav and the mobile drawer), so
 * the shell is now a simple stacked layout: a sticky top bar (MegaMenu + the
 * Header theme/sign-out controls) over a full-width content area.
 */

import { Outlet } from 'react-router';
import MegaMenu from './MegaMenu';
import Header from './Header';

export default function DashboardShell() {
  return (
    <div className="dashboard-topnav-layout">
      <div className="dashboard-topbar">
        <MegaMenu />
        <Header />
      </div>
      <div className="dashboard-content">
        <Outlet />
      </div>
    </div>
  );
}
